import { render, staticRenderFns } from "./yjDeatil.vue?vue&type=template&id=482bc15c&scoped=true&"
import script from "./yjDeatil.vue?vue&type=script&lang=js&"
export * from "./yjDeatil.vue?vue&type=script&lang=js&"
import style0 from "./yjDeatil.vue?vue&type=style&index=0&id=482bc15c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482bc15c",
  null
  
)

export default component.exports